// extracted by mini-css-extract-plugin
export default {"stepsWrapper":"Steps_stepsWrapper__Uy0dg","stepsHeading":"Steps_stepsHeading__4wCD9","stepsList":"Steps_stepsList__WL58a","fadeIn":"Steps_fadeIn__pQHpY"};